import Model, { type HasMany, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { Type } from '@warp-drive/core-types/symbols';
import type { ParityInsightSegmentationItem } from 'lumen/models';
import {
  SEGMENTATION_KEYS,
  type SegmentationKey,
} from 'lumen/models/parity/insight/segmentation-item';

export type BreakdownItemsPerExtractDate = Record<
  string,
  ParityInsightSegmentationItem[]
>;
type ItemsPerBreakdownAndDate = Record<
  SegmentationKey,
  BreakdownItemsPerExtractDate
>;

export default class ParityInsightHistoricalData extends Model {
  [Type] = 'parity/insight/historical-data' as const;

  @hasMany('parity/insight/segmentation-item', { async: false, inverse: null })
  declare items: HasMany<ParityInsightSegmentationItem>;

  get all(): BreakdownItemsPerExtractDate {
    return this.itemsPerBreakdownAndDate[SEGMENTATION_KEYS.ALL] ?? {};
  }

  @cached
  get itemsPerBreakdownAndDate(): ItemsPerBreakdownAndDate {
    const itemsByBreakdownAndDate = {} as ItemsPerBreakdownAndDate;
    this.items.forEach((item) => {
      const key = item.segmentationId;
      itemsByBreakdownAndDate[key] ??= {};
      (itemsByBreakdownAndDate[key][item.extractDate] ??= []).push(item);
    });

    return itemsByBreakdownAndDate;
  }

  getBreakdownData(key: SegmentationKey): BreakdownItemsPerExtractDate {
    return this.itemsPerBreakdownAndDate[key] ?? {};
  }
}
